import { render, staticRenderFns } from "./ClButton.html?vue&type=template&id=ddac06a4&"
import script from "./ClButton.ts?vue&type=script&lang=ts&"
export * from "./ClButton.ts?vue&type=script&lang=ts&"
import style0 from "./ClButton.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports